import React from 'react';

import { termsOfUseLink, privacyPolicyLink } from "utils/urls";

import Link from "@mui/material/Link";

import { t } from "i18n/index";

const FooterLabels = () => {
  return (
    <div className="footer-labels">
        <Link href={termsOfUseLink} target="_blank" color="inherit">
          {t("literal:termsAndConditions")}
        </Link>
        <Link href={privacyPolicyLink} target="_blank" color="inherit">
          {t("literal:privacyPolicy")}
        </Link>
        <p className="mbrz-label">
          Membrz Club {new Date().getFullYear()}
        </p>
      </div>
  );
};

export default FooterLabels;